import React from "react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { Pencil, Trash2 } from "lucide-react";

export const EditButton = ({ onClick, testid }) => (
  <button
    onClick={onClick}
    className="text-navy/50 hover:text-gold transition-colors p-1.5"
    aria-label="Edit"
    data-testid={testid}
  >
    <Pencil size={14} />
  </button>
);

export const DeleteButton = ({ onConfirm, testid, itemLabel = "this record" }) => (
  <AlertDialog>
    <AlertDialogTrigger asChild>
      <button
        className="text-navy/50 hover:text-red-600 transition-colors p-1.5"
        aria-label="Delete"
        data-testid={testid}
      >
        <Trash2 size={14} />
      </button>
    </AlertDialogTrigger>
    <AlertDialogContent>
      <AlertDialogHeader>
        <AlertDialogTitle className="serif-display text-2xl">Delete {itemLabel}?</AlertDialogTitle>
        <AlertDialogDescription>This action cannot be undone.</AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel>Cancel</AlertDialogCancel>
        <AlertDialogAction onClick={onConfirm} className="bg-red-600 hover:bg-red-700">
          Delete
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);

export const RowActions = ({ onEdit, onDelete, editTestid, deleteTestid, itemLabel }) => (
  <div className="flex items-center gap-1 justify-end">
    {onEdit && <EditButton onClick={onEdit} testid={editTestid} />}
    {onDelete && <DeleteButton onConfirm={onDelete} testid={deleteTestid} itemLabel={itemLabel} />}
  </div>
);
